export const getState = (key) => {
    const serializedState = localStorage.getItem(key);
    if (!serializedState) {
        return undefined;
    }

    const processedSerializedState = ['userJourneyId', 'reuSurveyCheckoutCartId', 'userJourneyCheckpointId'].includes(
        key,
    )
        ? serializedState?.replace(/['"]/g, '')
        : serializedState;

    return [
        'authToken',
        'reuCheckoutCartId',
        'reuPreviewCheckoutCartId',
        'selectedBroadcastId',
        'userJourneyId',
        'reuSurveyCheckoutCartId',
        'userJourneyCheckpointId',
    ].includes(key)
        ? processedSerializedState
        : (() => {
              try {
                  return JSON.parse(serializedState);
              } catch (e) {
                  console.error('Error parsing JSON from localStorage:', e);
                  return serializedState;
              }
          })();
};

export const setState = (key, data) => {
    const serializedState =
        typeof data === 'string' ||
        [
            'authToken',
            'reuCheckoutCartId',
            'reuPreviewCheckoutCartId',
            'selectedBroadcastId',
            'userJourneyId',
            'reuSurveyCheckoutCartId',
            'userJourneyCheckpointId',
        ].includes(key)
            ? data
            : JSON.stringify(data);
    localStorage.setItem(key, serializedState);
};

export const removeState = (key) => {
    localStorage.removeItem(key);
};

export const clearState = () => {
    localStorage.clear();
};

export const getAllLocalStorage = () => {
    const items = {};
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key) {
            items[key] = localStorage.getItem(key);
        }
    }
    return items;
};
